import { Button, Divider, message, Modal } from "antd";
import { UploadFile } from "antd/lib";
import { useEffect, useState } from "react";
import CatalogDirectLink from "../onlineProfile/direct-links/CatalogDirectLink";
import ServicesDirectLink from "../onlineProfile/direct-links/ServicesDirectLink";
import MembershipsDirectLink from "../onlineProfile/direct-links/MembershipsDirectLink";
import { adminUpdateLocationOnlineProfile } from "../../../network/admin";
import { useMutation } from "@tanstack/react-query";
import queryClient from "../../../services/react-query/queryClient";
import IMGUploader from "../../common/ui/IMGUploader";
import SalonGalleryImg from "../onlineProfile/SalonGalleryImg";

const OnlineBookingModal = ({ modal, closeModal, data }: any) => {
  console.log(data);
  const [logoImg, setLogoImg] = useState<UploadFile[]>([]);
  const [imgs, setImgs] = useState<Array<UploadFile | null>>([]);
  const [catalogModal, setCatalogModal] = useState(false);

  const [servicesModal, setServicesModal] = useState(false);
  const [memberShipModal, setMemberShipModal] = useState(false);
  const { mutate: onUpdateLocationLink, isLoading } = useMutation(
    (body: any) => adminUpdateLocationOnlineProfile(data?.id, body),
    {
      onSuccess: (res: any) => {
        if (res?.response?.status === 422 || res?.response?.status === 500) {
          message.error(res?.response?.data?.message);
        } else {
          queryClient.invalidateQueries(["location"]);
          message.success("Location Details updated successfully");
          // if (res?.data?.data?.have_catalog_link) {
          //   setCatalogModal(true);
          // }
        }
      },
      onError: (error) => {
        console.log("Add Category error:", error);
        message.error("حاول مرة اخرى");
      },
    }
  );
  const handleCreateLink = async (params: any) => {
    onUpdateLocationLink({
      ...params,
    });
    if (params?.link_type === "catalog_link") {
      setCatalogModal(true);
    }
    if (params?.link_type === "membership_link") {
      setMemberShipModal(true);
    }
    if (params?.link_type === "service_link") {
      setServicesModal(true);
    }
  };

  const handleRemoveLink = async (params: any) => {
    onUpdateLocationLink({
      ...params,
    });
  };
  const handleChangeImgs = () => {
    if (!logoImg[0]) {
      message.error("Logo is required");
      return;
    }
    const formData = new FormData();
    if (logoImg[0]?.originFileObj) {
      formData.append("logo", logoImg[0]?.originFileObj);
    }
    if (imgs) {
      imgs.forEach((img, index) => {
        if (img && img?.originFileObj) {
          formData.append(`gallery[${index}]`, img.originFileObj);
        }
      });
    }
    const imagesIndex = data?.settings?.findIndex(
      (item: any) => item?.key === "brand_gallery"
    );
    if (imagesIndex) {
      const imgsUids =
        data?.settings[imagesIndex]?.media?.map((img: any) => {
          if (img?.uuid) {
            return img?.uuid;
          }
        }) || [];

      imgs.forEach((img, i) => {
        if (img && !img.originFileObj) {
          if (img && img.uid) {
            const index = imgsUids.indexOf(img.uid);
            if (index > -1) {
              imgsUids.splice(index, 1);
            }
          }
        }
      });

      imgsUids.forEach((img: any, i: number) => {
        formData.append(`gallery_deleted_ids[${i}]`, img as string);
      });
    }
    onUpdateLocationLink(formData);
  };

  const initializeData = () => {
    if (data) {
      const logoIndex = data?.settings?.findIndex(
        (item: any) => item?.key === "brand_logo"
      );
      const imagesIndex = data?.settings?.findIndex(
        (item: any) => item?.key === "brand_gallery"
      );

      if (logoIndex >= 0) {
        if (
          typeof data?.settings[logoIndex]?.media[0]?.media_url === "string" &&
          data?.settings[logoIndex]?.media[0]?.media_url?.length > 0
        ) {
          setLogoImg([
            {
              uid: data?.settings[logoIndex]?.media[0]?.id,
              name: data?.settings[logoIndex]?.media[0]?.name,
              url: data?.settings[logoIndex]?.media[0]?.media_url,
            },
          ]);
        }
      }
      if (imagesIndex >= 0) {
        setImgs(() =>
          data?.settings[imagesIndex]?.media?.map((img: any, i: number) => {
            const file = {
              uid: img?.uuid,
              name: img?.name || "Gallery Image " + (i + 1),
              url: img?.media_url,
            };
            return file;
          })
        );
      }
    }
  };
  useEffect(() => {
    initializeData();
  }, [data]);

  return (
    <Modal
      centered
      open={modal}
      onCancel={closeModal}
      okButtonProps={{ disabled: true }}
      cancelButtonProps={{ disabled: true }}
      footer={null}
      width={1060}
      maskClosable={false}
      className="py-8 px-6"
      destroyOnClose
    >
      <div className="space-y-6">
        <div className="flex flex-col items-center justify-center w-full gap-2 mt-6">
          {" "}
          <h4 className="text-color-primary text-2xl font-semibold">
            Salon Online Profile
          </h4>
          <span className="text-[#75757E]">{data?.name}</span>
        </div>
        <div className="flex items-center justify-center w-full ">
          <IMGUploader
            name="logo"
            listType="picture-circle"
            fileList={logoImg}
            setFileList={setLogoImg}
            imgValidation
          />
        </div>
        <div className="my-8">
          <div className="space-y-4">
            <h5 className="text-color-primary text-lg font-semibold flex items-center justify-center">
              Salon Gallery
            </h5>

            <div className=" p-4 grid grid-cols-1 md:grid-cols-2 gap-4 lg:grid-cols-3 justify-center ">
              {
                // imgs?.map((img, i) => (
                Array.from(Array(6))?.map((img, i) => (
                  <SalonGalleryImg
                    imgs={imgs}
                    setImgs={setImgs}
                    index={i}
                    key={i}
                  />
                ))
              }
            </div>
          </div>
          <Divider />
          <div>
            <h5 className="text-color-primary text-lg font-semibold flex items-center justify-center">
              Direct links
            </h5>
            <div
              className={`p-4 flex justify-between ${
                data?.have_catalog_link ||
                data?.have_service_link ||
                data?.have_membership_link
                  ? "flex-col"
                  : " flex-row"
              } `}
            >
              <div className=" w-[800px] mx-auto">
                <CatalogDirectLink
                  locationLinksData={data}
                  isLoading={isLoading}
                  handleRemoveLink={handleRemoveLink}
                  handleCreateLink={handleCreateLink}
                  catalogModal={catalogModal}
                  setCatalogModal={setCatalogModal}
                />
              </div>
              <div className="w-[800px] mx-auto  ">
                <ServicesDirectLink
                  locationLinksData={data}
                  isLoading={isLoading}
                  handleRemoveLink={handleRemoveLink}
                  handleCreateLink={handleCreateLink}
                  servicesModal={servicesModal}
                  setServicesModal={setServicesModal}
                />
              </div>
              {/* <div className=" w-[800px]  mx-auto ">
                <MembershipsDirectLink
                  locationLinksData={data}
                  isLoading={isLoading}
                  handleRemoveLink={handleRemoveLink}
                  handleCreateLink={handleCreateLink}
                  memberShipModal={memberShipModal}
                  setMemberShipModal={setMemberShipModal}
                />
              </div> */}
            </div>
          </div>
        </div>
        <div className=" flex gap-6 w-full">
          <Button
            type="primary"
            htmlType="button"
            block
            onClick={handleChangeImgs}
          >
            Save Changes
          </Button>
          <Button
            type="default"
            htmlType="button"
            loading={isLoading}
            block
            onClick={closeModal}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default OnlineBookingModal;
